export default "__VITE_ASSET__1$4tlk3H__"